module.exports = __webpack_public_path__ + "img/5.9a56e6a4.jpg";